.styledForm {
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
  overflow: hidden;
  max-height: 90%;
}

.productsWithinListingHeader {
  padding: 0.5rem 1.25rem;
  background: var(--static-background-weak, #fff);
  border-bottom: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
}

.emptyBox {
  margin: 1.5rem;
  padding: 2.5rem;
  align-items: center;
  gap: 2rem;
  align-self: stretch;
  border-radius: 12px;
  background: var(--static-background-weak, #fafafa);
}

.emptySubText {
  text-align: center;
}

.listingItemsContainer {
  overflow-y: scroll;
  overflow-x: hidden;
  background: var(--static-background-standard, #fff);
  height: 100%;
  box-sizing: border-box;
}

.stateBox {
  display: flex;
  padding: 0.5rem 1rem;
  flex-direction: column;
  align-items: stretch;
  gap: 0.75rem;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  border-top: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
  background: var(--static-background-weak, #fafafa);
}